module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kanto-4-b049e0c7b3c4ad9cb915583ee930417a.jpg";